import React from 'react';
import PropTypes from 'prop-types';

const NextPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M25 4c-.552 0-1 .488-1 1.091v21.818c0 .602.448 1.091 1 1.091h2c.552 0 1-.489 1-1.091V5.091C28 4.488 27.552 4 27 4h-2zm-20.858.854A.786.786 0 0 0 4 5.305v21.39c0 .444.37.805.827.805a.846.846 0 0 0 .464-.138l15.923-10.473c.505-.332.638-.999.296-1.49a1.068 1.068 0 0 0-.296-.288L5.291 4.638a.84.84 0 0 0-.463-.138.83.83 0 0 0-.686.354z"
    />
  );
};

NextPath.propTypes = {
  fill: PropTypes.string,
};

export default NextPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/next.jsx